<template>
  <fieldset class="h-14 group-select">
    <div>
      <dl class="-my-4 divide-y divide-gray-200 text-sm">
        <div class="flex items-center justify-between py-4">
          <dt class="text-gray-600">
            Liczba uczestników
          </dt>
          <dd class="flex items-center font-medium text-gray-900">
            <button @click="decrement" class="px-2 py-1 bg-gray-300 rounded">-</button>
            <span class="py-1 mx-2 w-3">{{ count }}</span>
            <button @click="increment" class="px-2 py-1 bg-gray-300 rounded">+</button>
          </dd>
        </div>
      </dl>
    </div>
  </fieldset>
  <div v-if="error" class="text-sm text-red-600 mt-1">
    {{ error }}
  </div>
</template>

<script>
import { useI18n } from 'vue-i18n';

export default {
  name: 'CountSelector',
  props: {
    order: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      error: null
    };
  },
  computed: {
    count() {
      return this.order.getCount() || 0;
    }
  },
  methods: {
    increment() {
      const prevCount = this.count || 0;
      const newCount = prevCount + 1;
      this.order.setCount('all', newCount);

      // no change, inform that it's impossible to add more people in order
      if (prevCount === this.count) {
        this.error = "Limit osób w tym zamówieniu został osiągnięty. Dodaj kolejne osoby w nowym zamówieniu.";
      }
    },
    decrement() {
      this.error = null;
      if ((this.count || 0) > 0) {
        const newCount = (this.count || 0) - 1;
        this.order.setCount('all', newCount);
      }
    },
    getAgeRange(price) {
      if (!price || (!price.age_from && !price.age_to)) return '';
      if (price.age_from && price.age_to) return `(${price.age_from}-${price.age_to} lat)`;
      if (price.age_from) return `(${price.age_from}+ lat)`;
      if (price.age_to) return `(<${price.age_to} lat)`;
      return '';
    }
  },
  
  setup(props) {
    const { t } = useI18n();
    return {
      t
    };
  }
};
</script>